
import { defineComponent } from 'vue'
import { MenuItem } from 'primevue/menuitem'

export default defineComponent({
  data() {
    return {
      showSideMenuMobile: false
    }
  },
  methods: {
    showMenuMobile() {
      this.showSideMenuMobile = !this.showSideMenuMobile
    }
  },
  computed: {
    furnituresMenuItems(): MenuItem[] {
      return [
        {
          label: this.$t('side-menu.furnitures.categories'),
          items: [
            {
              label: this.$t('side-menu.furnitures.networks'),
              to: '/furnitures/networks',
              icon: 'ci-icon-layers',
              disabled: true
            },
            {
              label: this.$t('side-menu.furnitures.gateways'),
              to: '/furnitures/gateways',
              icon: 'ci-data-iot'
            },
            {
              label: this.$t('side-menu.furnitures.objects'),
              to: '/furnitures/objects',
              icon: 'ci-icon-layers'
            },
            {
              label: this.$t('side-menu.furnitures.tags'),
              to: '/furnitures/tags',
              icon: 'ci-icon-layers'
            }
          ]
        }
      ]
    }
  }
})
